var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.report.metric.card",
  title: "Artisan Metric Card",
  description: "Displays a dashboard metric for the Application Artisan Report.",
  styling: {
    styles: [
      {
        selector: ".app-artisan-metric-card",
        styles: [
          "backdrop-filter: blur(1.3rem);",
          "background: linear-gradient(180deg, rgba($background-color, 0.9) 0%, rgba($background-color, 0.78) 100%);",
          "border: 0.0625rem solid rgba($secondary, 0.24);",
          "border-radius: 1.75rem;",
          "box-shadow: 0 1.5rem 3rem rgba($background-color, 0.22);",
          "display: flex;",
          "flex-direction: column;",
          "gap: 0.9rem;",
          "min-height: 100%;",
          "min-width: 0;",
          "overflow: hidden;",
          "padding: 1.2rem 1.2rem 1.35rem;",
          "position: relative;",
          "transition: transform 0.5s ease, border-color 0.5s ease, box-shadow 0.5s ease, opacity 0.7s ease;",
          "opacity: 0;",
          "transform: translateY(1.2rem) scale(0.985);"
        ]
      },
      {
        selector: ".app-artisan-metric-card.is-visible",
        styles: [
          "opacity: 1;",
          "transform: translateY(0) scale(1);"
        ]
      },
      {
        selector: ".app-artisan-metric-card:hover",
        styles: [
          "border-color: rgba($primary, 0.42);",
          "box-shadow: 0 1.8rem 3.4rem rgba($background-color, 0.28);",
          "transform: translateY(-0.2rem);"
        ]
      },
      {
        selector: ".app-artisan-metric-card::after",
        styles: [
          "background: linear-gradient(90deg, rgba($primary, 0.3), rgba($info, 0.18), transparent);",
          "content: '';",
          "height: 0.125rem;",
          "inset: 0 auto auto 0;",
          "position: absolute;",
          "width: 100%;"
        ]
      },
      {
        selector: ".app-artisan-metric-card-featured",
        styles: [
          "justify-content: stretch;",
          "padding: 1.35rem 1.35rem 1.5rem;",
          "display: grid;",
          "align-content: start;",
          "align-items: center;",
          "justify-items: stretch;",
          "grid-template-rows: auto 1fr auto auto;"
        ]
      },
      {
        selector: ".app-artisan-metric-top",
        styles: [
          "align-items: flex-start;",
          "display: flex;",
          "gap: 0.9rem;",
          "justify-content: space-between;"
        ]
      },
      {
        selector: ".app-artisan-metric-top-main",
        styles: [
          "align-items: flex-start;",
          "display: flex;",
          "flex: 1 1 auto;",
          "gap: 0.8rem;",
          "min-width: 0;"
        ]
      },
      {
        selector: ".app-artisan-metric-heading",
        styles: [
          "display: flex;",
          "flex-direction: column;",
          "gap: 0.28rem;",
          "min-width: 0;"
        ]
      },
      {
        selector: ".app-artisan-metric-kicker",
        styles: [
          "color: rgba($text-color, 0.62);",
          "font-size: 0.78rem;",
          "font-weight: 700;",
          "letter-spacing: 0.08rem;",
          "line-height: 1.2;",
          "text-transform: uppercase;"
        ]
      },
      {
        selector: ".app-artisan-metric-heading-label",
        styles: [
          "font-size: 1rem;",
          "font-weight: 700;",
          "line-height: 1.25;",
          "max-width: 100%;",
          "overflow-wrap: break-word;",
          "word-break: normal;"
        ]
      },
      {
        selector: ".app-artisan-metric-icon",
        styles: [
          "align-items: center;",
          "background: rgba($primary, 0.12);",
          "border: 0.0625rem solid rgba($primary, 0.22);",
          "border-radius: 1rem;",
          "color: $text-color;",
          "display: inline-flex;",
          "flex: 0 0 auto;",
          "font-size: 1rem;",
          "height: 2.6rem;",
          "justify-content: center;",
          "width: 2.6rem;"
        ]
      },
      {
        selector: ".app-artisan-metric-pill",
        styles: [
          "flex: 0 0 auto;",
          "max-width: 100%;"
        ]
      },
      {
        selector: ".app-artisan-metric-value",
        styles: [
          "align-items: flex-end;",
          "display: flex;",
          "font-size: clamp(2.55rem, 5.2vw, 4.2rem);",
          "flex-wrap: wrap;",
          "font-weight: 800;",
          "gap: 0.55rem;",
          "justify-content: flex-start;",
          "letter-spacing: -0.05em;",
          "line-height: 0.92;",
          "max-width: 100%;",
          "overflow-wrap: anywhere;",
          "width: 100%;",
          "word-break: normal;"
        ]
      },
      {
        selector: ".app-artisan-metric-value-number",
        styles: [
          "flex: 1 1 auto;",
          "min-width: 0;"
        ]
      },
      {
        selector: ".app-artisan-metric-value-unit",
        styles: [
          "color: rgba($text-color, 0.62);",
          "font-size: 0.28em;",
          "font-weight: 700;",
          "letter-spacing: 0.06em;",
          "line-height: 1.1;",
          "text-transform: uppercase;"
        ]
      },
      {
        selector: ".app-artisan-metric-card-featured .app-artisan-metric-value",
        styles: [
          "align-items: flex-end;",
          "font-size: clamp(3.8rem, 8.4vw, 7rem);",
          "justify-content: space-between;",
          "line-height: 0.86;",
          "width: 100%;"
        ]
      },
      {
        selector: ".app-artisan-metric-card-featured .app-artisan-metric-value-number",
        styles: [
          "flex: 1 1 100%;",
          "width: 100%;"
        ]
      },
      {
        selector: ".app-artisan-metric-label",
        styles: [
          "font-size: 1rem;",
          "font-weight: 600;",
          "line-height: 1.45;"
        ]
      },
      {
        selector: ".app-artisan-metric-meta",
        styles: [
          "color: rgba($text-color, 0.62);",
          "font-size: 0.92rem;",
          "line-height: 1.5;",
          "overflow-wrap: anywhere;",
          "word-break: break-word;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-metric-card",
        styles: [
          "border-radius: 1.25rem;",
          "gap: 1rem;",
          "padding: 1.1rem 1rem 1.2rem;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-metric-top",
        styles: [
          "align-items: flex-start;",
          "flex-direction: column;",
          "gap: 0.7rem;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-metric-top-main",
        styles: [
          "width: 100%;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-metric-heading",
        styles: [
          "gap: 0.22rem;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-metric-heading-label",
        styles: [
          "font-size: 1.02rem;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-metric-value",
        styles: [
          "align-items: baseline;",
          "font-size: clamp(2.3rem, 11vw, 3.35rem);",
          "gap: 0.42rem;",
          "line-height: 0.96;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-metric-card-featured .app-artisan-metric-value",
        styles: [
          "align-items: baseline;",
          "font-size: clamp(2.85rem, 13vw, 4rem);",
          "justify-content: flex-start;",
          "line-height: 0.92;"
        ]
      },
      {
        device: "iphone",
        selector: ".app-artisan-metric-pill",
        styles: [
          "align-self: flex-start;"
        ]
      }
    ]
  },
  fields: {
    kicker: {
      type: "string",
      required: true,
      title: "Kicker",
      description: "Small label shown above the metric."
    },
    value: {
      type: "number",
      required: true,
      title: "Value",
      description: "The numeric value to display."
    },
    label: {
      type: "string",
      required: true,
      title: "Label",
      description: "Primary label for the metric."
    },
    meta: {
      type: "string",
      title: "Meta",
      description: "Secondary helper text."
    },
    pill: {
      type: "string",
      title: "Pill",
      description: "Optional pill label."
    },
    tone: {
      type: "string",
      title: "Tone",
      description: "Visual tone for the pill.",
      default: "warm"
    },
    icon: {
      type: "string",
      title: "Icon",
      description: "Optional Bootstrap icon class suffix."
    },
    valueUnit: {
      type: "string",
      title: "Value Unit",
      description: "Optional unit label for the numeric value."
    },
    class: {
      type: "string",
      title: "Class",
      description: "Optional extra class name."
    }
  }
});

exports.render = async function renderMetricCard(options) {
  return {
    n: "div",
    c: "app-artisan-metric-card" + (options.class ? " " + options.class : ""),
    "data-artisan-pop": "true",
    i: [
      {
        n: "div",
        c: "app-artisan-metric-top",
        i: [
          {
            n: "div",
            c: "app-artisan-metric-top-main",
            i: [
              options.icon ? {
                n: "span",
                c: "app-artisan-metric-icon",
                i: {
                  n: "i",
                  c: "bi " + options.icon
                }
              } : "",
              {
                n: "div",
                c: "app-artisan-metric-heading",
                i: [
                  {
                    n: "span",
                    c: "app-artisan-metric-kicker",
                    i: options.kicker
                  },
                  {
                    n: "span",
                    c: "app-artisan-metric-heading-label",
                    i: options.label
                  }
                ]
              }
            ]
          },
          options.pill ? {
            n: "span",
            c: "app-artisan-pill app-artisan-pill-" + (options.tone || "warm") + " app-artisan-metric-pill",
            i: options.pill
          } : ""
        ]
      },
      {
        n: "div",
        c: "app-artisan-metric-value",
        i: [
          {
            n: "span",
            c: "app-artisan-metric-value-number",
            "data-artisan-number": options.value,
            i: Number(options.value || 0).toLocaleString("en-US")
          },
          options.valueUnit ? {
            n: "span",
            c: "app-artisan-metric-value-unit",
            i: options.valueUnit
          } : ""
        ]
      },
      {
        n: "div",
        c: "app-artisan-metric-label",
        i: options.label || "Latest report reading"
      },
      options.meta ? {
        n: "div",
        c: "app-artisan-metric-meta",
        i: options.meta
      } : ""
    ]
  };
};
